import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout pageTitle="About Us">
    <SEO title="About" />
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Assumenda iure
      asperiores vitae quasi maiores est ducimus maxime cum velit sed officia,
      voluptate soluta ab numquam distinctio dolore. Eveniet delectus, quas
      autem adipisci vero eum sapiente, quo, facere quasi ducimus voluptate cum
      non doloremque quos. Libero tempore eaque veniam voluptate repellendus
      autem ut. Libero nesciunt eum temporibus? Nemo corrupti fugiat animi
      architecto quasi officiis modi ducimus neque! Reprehenderit sapiente amet
      rerum maxime nihil iste at molestias commodi, obcaecati molestiae.
      Repellat fugiat odit minus, illo earum consequatur porro nobis odio
      laborum sed accusamus officia omnis eveniet ducimus natus magni est.
      Cumque, quaerat.
    </p>
  </Layout>
)

export default AboutPage
